// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.112.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.112.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.help-and-support-modal {
  display: flex;
  flex-direction: column;
  width: 561px;
  font-family: Rubik;
  font-feature-settings: 'clig' off, 'liga' off;
  font-style: normal;
}
.help-and-support-modal__header {
  margin: 24px 24px 0 24px;
}
.help-and-support-modal__header h1 {
  color: #1a2026;
  font-size: 24px;
  font-weight: 400;
  line-height: 125%;
}
.help-and-support-modal__content {
  margin: 16px 24px 16px 24px;
  color: #69717a;
  font-size: 14px;
}
.help-and-support-modal__content p {
  line-height: 150%;
}
.help-and-support-modal__content a {
  color: #006ae1;
  text-decoration-line: underline;
}
.help-and-support-modal__actions {
  display: flex;
  justify-content: flex-end;
  margin: 16px 24px 16px 24px;
}
.help-and-support-modal__actions__close-btn {
  width: 89px;
}
.help-and-support-modal--small {
  width: 295px;
}
.help-and-support-modal--small .help-and-support-modal__actions__close {
  width: 247px;
}
/*# sourceMappingURL=index.css.map */`, "",{"version":3,"sources":["webpack://./index.less","webpack://./src/components/modals/help-and-support-modal/index.less"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,6CAAA;EAGA,kBAAA;ACHF;ADKE;EACE,wBAAA;ACHJ;ADEE;EAII,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;ACHN;ADOE;EACE,2BAAA;EACA,cAAA;EACA,eAAA;ACLJ;ADEE;EAMI,iBAAA;ACLN;ADDE;EAUI,cAAA;EACA,+BAAA;ACNN;ADUE;EACE,aAAA;EACA,yBAAA;EACA,2BAAA;ACRJ;ADUI;EACE,WAAA;ACRN;ADYE;EACE,YAAA;ACVJ;ADSE;EAII,YAAA;ACVN;AACA,oCAAoC","sourcesContent":["@import '../../../style/colors.less';\n\n.help-and-support-modal {\n  display: flex;\n  flex-direction: column;\n  width: 561px;\n  font-family: Rubik;\n  font-feature-settings:\n    'clig' off,\n    'liga' off;\n  font-style: normal;\n\n  &__header {\n    margin: 24px 24px 0 24px;\n\n    h1 {\n      color: @TextIconInteractive-base;\n      font-size: 24px;\n      font-weight: 400;\n      line-height: 125%;\n    }\n  }\n\n  &__content {\n    margin: 16px 24px 16px 24px;\n    color: @TextIconInteractive-soft;\n    font-size: 14px;\n\n    p {\n      line-height: 150%;\n    }\n\n    a {\n      color: @TextIconInteractive-interactive;\n      text-decoration-line: underline;\n    }\n  }\n\n  &__actions {\n    display: flex;\n    justify-content: flex-end;\n    margin: 16px 24px 16px 24px;\n\n    &__close-btn {\n      width: 89px;\n    }\n  }\n\n  &--small {\n    width: 295px;\n\n    .help-and-support-modal__actions__close {\n      width: 247px;\n    }\n  }\n}\n",".help-and-support-modal {\n  display: flex;\n  flex-direction: column;\n  width: 561px;\n  font-family: Rubik;\n  font-feature-settings: 'clig' off, 'liga' off;\n  font-style: normal;\n}\n.help-and-support-modal__header {\n  margin: 24px 24px 0 24px;\n}\n.help-and-support-modal__header h1 {\n  color: #1a2026;\n  font-size: 24px;\n  font-weight: 400;\n  line-height: 125%;\n}\n.help-and-support-modal__content {\n  margin: 16px 24px 16px 24px;\n  color: #69717a;\n  font-size: 14px;\n}\n.help-and-support-modal__content p {\n  line-height: 150%;\n}\n.help-and-support-modal__content a {\n  color: #006ae1;\n  text-decoration-line: underline;\n}\n.help-and-support-modal__actions {\n  display: flex;\n  justify-content: flex-end;\n  margin: 16px 24px 16px 24px;\n}\n.help-and-support-modal__actions__close-btn {\n  width: 89px;\n}\n.help-and-support-modal--small {\n  width: 295px;\n}\n.help-and-support-modal--small .help-and-support-modal__actions__close {\n  width: 247px;\n}\n/*# sourceMappingURL=index.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
